import { render, staticRenderFns } from "./ReviewPhd.vue?vue&type=template&id=a307d14c&scoped=true&"
import script from "./ReviewPhd.vue?vue&type=script&lang=js&"
export * from "./ReviewPhd.vue?vue&type=script&lang=js&"
import style0 from "./ReviewPhd.vue?vue&type=style&index=0&id=a307d14c&prod&lang=css&"
import style1 from "./ReviewPhd.vue?vue&type=style&index=1&id=a307d14c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a307d14c",
  null
  
)

export default component.exports